import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config';
import App from './App';

// Set initial theme synchronously before React renders
(function setInitialTheme() {
  const savedTheme = localStorage.getItem('theme');
  const theme = (savedTheme === 'light' || savedTheme === 'dark') ? savedTheme : 'dark';
  document.documentElement.setAttribute('data-theme', theme);
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
